import { FundsType } from '../../../types/masterTypes';

export const SET_CHOSEN_FUNDS_TYPE = 'SET_CHOSEN_FUNDS_TYPE';

export type SetChosenFundsTypeAction = {
  type: string;
  chosenFundsType: FundsType;
};

export const setChosenFundsType = (chosenFundsType: FundsType): SetChosenFundsTypeAction => ({
  type: SET_CHOSEN_FUNDS_TYPE,
  chosenFundsType
});
